<template>
  <BaseModal
    :modalTitle="$t('area.dhl.sandbox.title')"
    :modalIntro="$t('area.dhl.sandbox.intro')">
    <template #titleBadge>
      <DevBadge />
    </template>
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-1">
        <UiBaseButton
          variant="secondary"
          :text="$t('area.dhl.sandbox.label.standard-efi')"
          :isLoading="connectingPreset === 'standard'"
          :isDisabled="!!connectingPreset"
          @button-click="connect('standard')" />
        <span class="text-sm opacity-60">{{ $t('area.dhl.sandbox.message.standard-description') }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <UiBaseButton
          variant="secondary"
          :text="$t('area.dhl.sandbox.label.label-free')"
          :isLoading="connectingPreset === 'labelFree'"
          :isDisabled="!!connectingPreset"
          @button-click="connect('labelFree')" />
        <span class="text-sm opacity-60">{{ $t('area.dhl.sandbox.message.label-free-description') }}</span>
      </div>
    </div>
  </BaseModal>
</template>

<script lang="ts">
import { useAccountStore } from '@/stores/accountStore'
import { useToast } from '@/globals/typescript/utils/toast'
import { mapActions } from 'pinia'

/**
 * DHL sandbox test accounts — both share the same account number. See
 * `_Assets/DHL/Sandbox Test Credentials.md` in the brain for source/context.
 * Dev-only shortcut, opened from the DHL integration menu's DEV item — never
 * shown outside dev tooling.
 */
const DHL_SANDBOX_CREDENTIALS = {
  standard: {
    accountNumber: '302630464',
    apiUsername: 'efiDK',
    apiPassword: 'A@0oW^5xY#2eC^8o',
  },
  labelFree: {
    accountNumber: '302630464',
    apiUsername: 'dktestDK',
    apiPassword: 'W!1aF^3kK$8k',
  },
} as const

export default {
  name: 'DhlSandboxConnectModal',

  emits: ['close'],

  data() {
    return {
      connectingPreset: null as keyof typeof DHL_SANDBOX_CREDENTIALS | null,
    }
  },

  methods: {
    ...mapActions(useAccountStore, ['updateDhlSettings']),

    async connect(preset: keyof typeof DHL_SANDBOX_CREDENTIALS) {
      this.connectingPreset = preset
      try {
        await this.updateDhlSettings({ ...DHL_SANDBOX_CREDENTIALS[preset] })
        useToast().success(this.$t('area.dhl.credentials.message.saved'))
        this.$emit('close')
      } catch {
        useToast().error(this.$t('error.common.standard'))
      } finally {
        this.connectingPreset = null
      }
    },
  },
}
</script>
